// import React, { useState, useEffect } from "react";
// import "../../src/App.css";
// import { useNavigate } from "react-router-dom";
// import ProgramWiseProjects from "../Components/Graphs/projectDashboardGraphs/ProgramWiseProject";
// import ProjectStageWise from "../Components/Graphs/projectDashboardGraphs/ProjectStageWise";
// import SBUWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/SBUWorkloadGraph";
// import TLWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/TLWorkloadGraph";
// import ValidatorWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/ValidatorWorkloadGraph";
// import TraineeWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/TraineeWorkloadGraph";
// import RegionWiseProjectGraph from "../Components/Graphs/projectDashboardGraphs/RegionWiseProjectGraph";
// import ContractSignedMonthlyGraph from "../Components/Graphs/projectDashboardGraphs/ContractSignedMonthlyGraph";
// import KickoutMontlyWiseGraph from "../Components/Graphs/projectDashboardGraphs/KickoutMonthlyWiseGraph";
// import ProjectMovingDateWise from "../Components/Graphs/projectDashboardGraphs/ProjectMovingDateWise";
// import { DatePicker, Spin } from "antd";
// import moment from "moment";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import ProjectStageBar from "../Components/Graphs/projectDashboardGraphs/ProjectStageBar";
// import RFIMonthly from "../Components/Graphs/projectDashboardGraphs/RFIMonthly";
// import KickoutRFI from "../Components/Graphs/projectDashboardGraphs/KickoutRFI";
// import {
//   API_HEADER,
//   getStatsData,
//   project_wise_project_url,
//   project_insights_counts,
//   get_total_data_url,
// } from "../config";
// import axios from "axios";
// import KickoutMontlyWiseGraphTR from "../Components/Graphs/projectDashboardGraphs/KickoutMonthlyWiseGraphTR";
// import KickoutMontlyWiseGraphCC from "../Components/Graphs/projectDashboardGraphs/KickoutMonthlyGraphCC";

// const ProjectDashboard = () => {
//   const navigate = useNavigate();
//   const dateFormat = "DD/MM/YYYY";

//   const [totalProject, setTotalProject] = useState(0);
//   const [counter, setCounter] = useState({});
//   const [search, setSearch] = useState(false);

//   const [startDate, setstartDate] = useState(null);
//   const [fy, setFY] = useState("2024-2025");

//   const [endDate, setendDate] = useState(null);
//   const [loader, setLoader] = useState(false);

//   useEffect(() => {
//     const getProposalScopeWise = async () => {
//       const payload = { fy: "" };
//       const reqData = await axios.post(`${getStatsData}`, payload, API_HEADER);
//       setTotalProject(reqData.data.total_count);
//     };

//     getProposalScopeWise();
//   }, []);

//   // useEffect(() => {
//   //   const getCounter = async () => {
//   //     const payload = {
//   //       fy: fy,
//   //       // 'start_date': startDate ? startDate.format('YYYY-MM-DD') : null,
//   //       // 'end_date': endDate ? endDate.format('YYYY-MM-DD') : null,
//   //     };
//   //     // const reqData = await axios.post(`${get_total_data_url}`,payload, API_HEADER);
//   //     // const MyprogramwiseData = reqData.data.totals;
//   //     // setCounter(MyprogramwiseData)
//   //     const reqData = await axios.post(
//   //       `${project_wise_project_url}`,
//   //       payload,
//   //       API_HEADER
//   //     );
//   //     console.log("reqData", reqData);
//   //     const MyprogramwiseData = reqData.data.totals;
//   //     setCounter(MyprogramwiseData);
//   //   };

//   //   getCounter();
//   // }, [fy]);

//     useEffect(() => {
//     const getCounter = async () => {
//       const payload = {
//         fy: fy,
//       };

//       const reqData = await axios.post(
//         `${project_insights_counts}`,
//         payload,
//         API_HEADER
//       );
//       console.log("reqData", reqData);
//       const MyprogramwiseData = reqData.data.counts;
//       setCounter(MyprogramwiseData);
//     };

//     getCounter();
//   }, [fy]);

//   const handleClick = () => {
//     navigate("/dashboard");
//   };

//   const handleSearchByColumn = (value) => {
//     if (startDate && endDate) {
//       if (startDate.isAfter(endDate)) {
//         alert("Start Date cannot be after End Date.");
//         setendDate(null);
//         setstartDate(null);
//         return;
//       }
//     }
//     setSearch(!search);
//   };

//   const resetFilters = () => {
//     setendDate(null);
//     setstartDate(null);
//     setSearch(!search);
//   };

//   const handleDownload = async () => {
//     setLoader(true);

//     const pdf = new jsPDF();
//     const sections = document.querySelectorAll(".page-break"); // Use class to target sections

//     for (let i = 0; i < sections.length; i++) {
//       const section = sections[i];
//       const canvas = await html2canvas(section);
//       const imgData = canvas.toDataURL("image/png");

//       if (i > 0) {
//         pdf.addPage();
//       }

//       pdf.addImage(imgData, "PNG", 0, 0, 210, 297); // Adjust dimensions as needed
//     }

//     pdf.save("document.pdf");
//     setLoader(false);
//   };

//   const navigateToAllProjects = async () => {
//     navigate("/totalprojectsat");
//   };

//   return (
//     <>
//       <Spin spinning={loader}>
//         <div className="content dashboardcolor">
//           <div className="container-fluid">
//             <div className="row">
//               <div className="col-12 my-4">
//                 <div className="my-3 mx-4 d-flex align-items-center justify-content-between">
//                   <h3 className="font-weight-bold">Project Dashboard</h3>

//                   <div className="d-flex">
//                     <button
//                       className="mx-2 btn btn-light"
//                       onClick={navigateToAllProjects}
//                     >
//                       Total Project : {totalProject}
//                     </button>

//                     <button
//                       type="button"
//                       className="mx-2 btn btn-outline-success"
//                       onClick={handleClick}
//                     >
//                       Home
//                     </button>

//                     {/* <button className="mx-2 btn btn-primary" onClick={handleDownload}>Download</button> */}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="row mx-4">
//               <div className="col-sm-3 col-md-2">
//                 <div className="mb-3">
//                   <label className="text-capitalize textcolumntitle  fw-bold font12px">
//                     Start Date
//                   </label>
//                   <DatePicker
//                     onChange={(date, dateString) => setstartDate(date)}
//                     placeholder="From Date"
//                     style={{ width: "100%" }}
//                     className="rounded-2"
//                     format={dateFormat}
//                     showTime={false}
//                     value={startDate}
//                     // disabledDate={(current) =>
//                     //   current && current > moment().endOf("day")
//                     // }
//                   />
//                 </div>
//               </div>

//               <div className="col-sm-3 col-md-2">
//                 <div className="mb-3">
//                   <label className="text-capitalize textcolumntitle  fw-bold font12px">
//                     End Date
//                   </label>
//                   <DatePicker
//                     onChange={(date, dateString) => setendDate(date)}
//                     placeholder="To Date"
//                     style={{ width: "100%" }}
//                     className="rounded-2"
//                     format={dateFormat}
//                     showTime={false}
//                     value={endDate}
//                     // disabledDate={(current) =>
//                     //   current && current > moment().endOf("day")
//                     // }
//                   />
//                 </div>
//               </div>

//               <div className="col-sm-3 col-md-2 mt-4">
//                 <button
//                   className="btn btn-success btn-md rounded-2 me-2"
//                   onClick={handleSearchByColumn}
//                 >
//                   Search
//                 </button>

//                 <button
//                   className="btn btn-danger btn-md rounded-2"
//                   onClick={resetFilters}
//                 >
//                   Reset
//                 </button>
//               </div>

//               <div className="col-sm-3 col-md-2 ms-auto">
//                 <div className="mb-3">
//                   <label className="text-capitalize textcolumntitle fw-bold font12px">
//                     Select FY
//                   </label>
//                   <select
//                     id="member"
//                     className="form-select borderlightgreen form-select-sm "
//                     aria-label="Default select example"
//                     name="status"
//                     value={fy}
//                     onChange={(e) => {
//                       setFY(e.target.value);
//                     }}
//                     required
//                   >
//                     <option value="2024-2025">2024-2025</option>
//                     <option value="2025-2026">2025-2026</option>
//                   </select>
//                 </div>
//               </div>
//             </div>

//             <div className="page-break">
//               <div className="d-flex  justify-content-around my-4">
//                 <div
//                   className="border-1 border border-light-subtle p-3 rounded-3 text-bold"
//                   style={{ backgroundColor: "#E7F8F7" }}
//                 >
//                   Total Contract Signed: {counter?.total_contract_signed}

//                 </div>
//                 <div
//                   className="border-1 border border-light-subtle p-3 rounded-3 text-bold"
//                   style={{ backgroundColor: "#E7F8F7" }}
//                 >
//                   Total Ongoing Projects: {counter?.total_ongoing_project}
//                 </div>
//                 <div
//                   className="border-1 border border-light-subtle p-3 rounded-3 text-bold"
//                   style={{ backgroundColor: "#E7F8F7" }}
//                 >
//                   Total Submitted: {counter?.total_submitted_project}
//                 </div>
//                 <div
//                   className="border-1 border border-light-subtle p-3 rounded-3 text-bold"
//                   style={{ backgroundColor: "#E7F8F7" }}
//                 >
//                   Total Kickout: {counter?.total_kickout}
//                 </div>
//               </div>
//               <div className="row mx-4 graph">
//                 <div className="col-12 col-md-12 col-lg-12 col-sm-12  my-2 ">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Program Wise Projects</h4>
//                       <ProgramWiseProjects
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4 graph">
//                 {/* <div className="col-12 col-md-12 col-lg-12 col-sm-12 my-4 ">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Projects in Different Stages</h4>
//                       <ProjectStageWise
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div> */}

//                 <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Project Stages</h4>
//                       <ProjectStageBar
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4 graph">
//                 <div className="col-12 col-md-12 col-lg-12 col-sm-12 my-2 ">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>SBU Head WorkLoad</h4>
//                       <SBUWorkloadGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Team Leader WorkLoad</h4>
//                       <TLWorkloadGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4">
//                 <div className="col-12 col-md-12 col-lg-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Validator/Verifier Workload</h4>
//                       <ValidatorWorkloadGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 col-md-12 col-lg-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Trainee Workload</h4>
//                       <TraineeWorkloadGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="page-break">
//               <div className="row mx-4">
//                 <div className="col-12 col-md-12 col-lg-12 col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Region Wise Projects</h4>
//                       <RegionWiseProjectGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4">
//                 <div className="col-8 col-md-12 col-lg-8  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Kickout Month Wise</h4>
//                       <KickoutMontlyWiseGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-4 col-md-12 col-lg-4  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Project Delayed</h4>
//                       <ProjectMovingDateWise
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4">
//                 <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Contracts Signed vs Delivered</h4>
//                       <ContractSignedMonthlyGraph
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4">
//                 {/* <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Project Stages</h4>
//                       <ProjectStageBar />
//                     </div>
//                   </div>
//                 </div> */}
//               </div>

//               <div className="row mx-4">
//                 <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>RFI Initial Submission</h4>
//                       <RFIMonthly
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4">
//                 <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>RFI Resubmission</h4>
//                       <KickoutRFI
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mx-4">
//                 <div className="col-6 col-md-12 col-lg-6  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Month Wise TR</h4>
//                       <KickoutMontlyWiseGraphTR
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-6 col-md-12 col-lg-6  col-sm-12 my-2 graph">
//                   <div class="mycard_dash">
//                     <div class="mycard-content text-center">
//                       <h4>Month Wise CC</h4>
//                       <KickoutMontlyWiseGraphCC
//                         search={search}
//                         startDate={startDate}
//                         endDate={endDate}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Spin>
//     </>
//   );
// };

// export default ProjectDashboard;

import React, { useState, useEffect } from "react";
import "../../src/App.css";
import { useNavigate } from "react-router-dom";
import ProgramWiseProjects from "../Components/Graphs/projectDashboardGraphs/ProgramWiseProject";
import ProjectStageWise from "../Components/Graphs/projectDashboardGraphs/ProjectStageWise";
import SBUWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/SBUWorkloadGraph";
import TLWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/TLWorkloadGraph";
import ValidatorWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/ValidatorWorkloadGraph";
import TraineeWorkloadGraph from "../Components/Graphs/projectDashboardGraphs/TraineeWorkloadGraph";
import RegionWiseProjectGraph from "../Components/Graphs/projectDashboardGraphs/RegionWiseProjectGraph";
import ContractSignedMonthlyGraph from "../Components/Graphs/projectDashboardGraphs/ContractSignedMonthlyGraph";
import KickoutMontlyWiseGraph from "../Components/Graphs/projectDashboardGraphs/KickoutMonthlyWiseGraph";
import ProjectMovingDateWise from "../Components/Graphs/projectDashboardGraphs/ProjectMovingDateWise";
import { DatePicker, Spin } from "antd";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ProjectStageBar from "../Components/Graphs/projectDashboardGraphs/ProjectStageBar";
import RFIMonthly from "../Components/Graphs/projectDashboardGraphs/RFIMonthly";
import KickoutRFI from "../Components/Graphs/projectDashboardGraphs/KickoutRFI";
import { Tooltip } from "bootstrap";

import {
  API_HEADER,
  getStatsData,
  project_wise_project_url,
  project_insights_counts,
  get_total_data_url,
  getFinancialYears,
} from "../config";
import axios from "axios";
import KickoutMontlyWiseGraphTR from "../Components/Graphs/projectDashboardGraphs/KickoutMonthlyWiseGraphTR";
import KickoutMontlyWiseGraphCC from "../Components/Graphs/projectDashboardGraphs/KickoutMonthlyGraphCC";

const ProjectDashboard = () => {
  const navigate = useNavigate();
  const dateFormat = "DD/MM/YYYY";

  const [totalProject, setTotalProject] = useState(0);
  const [counter, setCounter] = useState({});
  const [search, setSearch] = useState(false);

  const [startDate, setstartDate] = useState(null);

  const [endDate, setendDate] = useState(null);
  const [loader, setLoader] = useState(false);
  const [financialYear, setfinancialYear] = useState([]);

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // getMonth() returns 0-indexed month

    if (month >= 4) {
      // From April to December
      return `${year}-${year + 1}`;
    } else {
      // From January to March
      return `${year - 1}-${year}`;
    }
  };

  const [fy, setFY] = useState(getCurrentFinancialYear());

  const counterDetails = {
    total_contract_signed:
      "Total no. of projects for which contracts are signed during selected FY",
    total_ongoing_project:
      "Total no. of ongoing projects (excluding RFI complete, Issued Register, Terminated, Onhold and Inactive stage) during selected FY ",
    total_submitted_project:
      "Total no. of projects with RFI Completed and submitted for final review during selected FY",
    total_kickout: "Total no. of projects  in Kickout Stage during selected FY",
  };

  // const setfinancialYear = ["2024-2025", "2025-2026","Overall"]

  //Tooltip
  useEffect(() => {
    // Initialize tooltips on all buttons with data-bs-toggle="tooltip"
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((el) => new Tooltip(el));
  }, []);

  useEffect(() => {
    const getProposalScopeWise = async () => {
      const payload = { fy: "" };
      const reqData = await axios.post(`${getStatsData}`, payload, API_HEADER);
      setTotalProject(reqData.data.total_count);
    };

    getProposalScopeWise();
  }, []);

  useEffect(() => {
    const fetchYear = async () => {
      const reqData = await axios.get(`${getFinancialYears}`, API_HEADER);
      setfinancialYear(reqData.data.financial_years);
    };

    fetchYear();
  }, []);

  // useEffect(() => {
  //   const getCounter = async () => {
  //     const payload = {
  //       fy: fy,
  //       // 'start_date': startDate ? startDate.format('YYYY-MM-DD') : null,
  //       // 'end_date': endDate ? endDate.format('YYYY-MM-DD') : null,
  //     };
  //     // const reqData = await axios.post(`${get_total_data_url}`,payload, API_HEADER);
  //     // const MyprogramwiseData = reqData.data.totals;
  //     // setCounter(MyprogramwiseData)
  //     const reqData = await axios.post(
  //       `${project_wise_project_url}`,
  //       payload,
  //       API_HEADER
  //     );
  //     console.log("reqData", reqData);
  //     const MyprogramwiseData = reqData.data.totals;
  //     setCounter(MyprogramwiseData);
  //   };

  //   getCounter();
  // }, [fy]);

  useEffect(() => {
    const getCounter = async () => {
      setLoader(true);
      const payload = {
        fy: fy == "Overall" ? "" : fy,
      };

      console.log("ppp", payload);

      const reqData = await axios.post(
        `${project_insights_counts}`,
        payload,
        API_HEADER
      );
      console.log("reqData", reqData);
      const MyprogramwiseData = reqData.data.counts;
      setCounter(MyprogramwiseData);
      setLoader(false);
    };

    getCounter();
  }, [fy]);

  const handleClick = () => {
    navigate("/dashboard");
  };

  const handleSearchByColumn = (value) => {
    if (startDate && endDate) {
      if (startDate.isAfter(endDate)) {
        alert("Start Date cannot be after End Date.");
        setendDate(null);
        setstartDate(null);
        return;
      }
    }
    setSearch(!search);
  };

  const resetFilters = () => {
    setendDate(null);
    setstartDate(null);
    setSearch(!search);
  };

  const handleDownload = async () => {
    setLoader(true);

    const pdf = new jsPDF();
    const sections = document.querySelectorAll(".page-break"); // Use class to target sections

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const canvas = await html2canvas(section);
      const imgData = canvas.toDataURL("image/png");

      if (i > 0) {
        pdf.addPage();
      }

      pdf.addImage(imgData, "PNG", 0, 0, 210, 297); // Adjust dimensions as needed
    }

    pdf.save("document.pdf");
    setLoader(false);
  };

  const navigateToAllProjects = async () => {
    navigate("/totalprojectsat");
  };

  return (
    <>
      <Spin spinning={loader}>
        <div className="content dashboardcolor">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 my-4">
                <div className="my-3 mx-4 d-flex align-items-center justify-content-between">
                  <h3 className="font-weight-bold">Project Dashboard</h3>

                  <div className="d-flex">
                    <button
                      className="mx-2 btn btn-light"
                      onClick={navigateToAllProjects}
                    >
                      Total Project : {totalProject}
                    </button>

                    <button
                      type="button"
                      className="mx-2 btn btn-outline-success"
                      onClick={handleClick}
                    >
                      Home
                    </button>

                    {/* <button className="mx-2 btn btn-primary" onClick={handleDownload}>Download</button> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-4">
              <div className="col-sm-3 col-md-2">
                <div className="mb-3">
                  <label className="text-capitalize textcolumntitle  fw-bold font12px">
                    Start Date
                  </label>
                  <DatePicker
                    onChange={(date, dateString) => setstartDate(date)}
                    placeholder="From Date"
                    style={{ width: "100%" }}
                    className="rounded-2"
                    format={dateFormat}
                    showTime={false}
                    value={startDate}
                    // disabledDate={(current) =>
                    //   current && current > moment().endOf("day")
                    // }
                  />
                </div>
              </div>

              <div className="col-sm-3 col-md-2">
                <div className="mb-3">
                  <label className="text-capitalize textcolumntitle  fw-bold font12px">
                    End Date
                  </label>
                  <DatePicker
                    onChange={(date, dateString) => setendDate(date)}
                    placeholder="To Date"
                    style={{ width: "100%" }}
                    className="rounded-2"
                    format={dateFormat}
                    showTime={false}
                    value={endDate}
                    // disabledDate={(current) =>
                    //   current && current > moment().endOf("day")
                    // }
                  />
                </div>
              </div>

              <div className="col-sm-3 col-md-2 mt-4">
                <button
                  className="btn btn-success btn-md rounded-2 me-2"
                  onClick={handleSearchByColumn}
                >
                  Search
                </button>

                <button
                  className="btn btn-danger btn-md rounded-2"
                  onClick={resetFilters}
                >
                  Reset
                </button>
              </div>

              <div className="col-sm-3 col-md-2 ms-auto">
                <div className="mb-3">
                  <label className="text-capitalize textcolumntitle fw-bold font12px">
                    Select FY
                  </label>
                  <select
                    id="member"
                    className="form-select borderlightgreen form-select-sm "
                    aria-label="Default select example"
                    name="status"
                    value={fy}
                    onChange={(e) => {
                      setFY(e.target.value);
                    }}
                    required
                  >
                    {/* <option value="2024-2025">2024-2025</option>
                    <option value="2025-2026">2025-2026</option> */}

                    {financialYear.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className="page-break">
              <div className="d-flex justify-content-around my-4">
                {/* Box 1: Total Contract Signed */}
                <div
                  className="border-1 border border-light-subtle p-3 rounded-3 text-bold d-flex align-items-center"
                  style={{ backgroundColor: "#E7F8F7" }}
                >
                  <button
                    className="btn btn-sm btn-link p-1 me-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={counterDetails.total_contract_signed}
                  >
                    <i className="bi bi-info-circle"></i>
                  </button>
                  <span className="flex-grow-1">
                    Total Contract Signed: {counter?.total_contract_signed}
                  </span>
                </div>

                {/* Box 2: Total Ongoing Projects */}
                <div
                  className="border-1 border border-light-subtle p-3 rounded-3 text-bold d-flex align-items-center"
                  style={{ backgroundColor: "#E7F8F7" }}
                >
                  <button
                    className="btn btn-sm btn-link p-1 me-2 "
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={counterDetails.total_ongoing_project}
                  >
                    <i className="bi bi-info-circle"></i>
                  </button>
                  <span className="flex-grow-1">
                    Total Ongoing Projects: {counter?.total_ongoing_project}
                  </span>
                </div>

                {/* Box 3: Total Submitted */}
                <div
                  className="border-1 border border-light-subtle p-3 rounded-3 text-bold d-flex align-items-center"
                  style={{ backgroundColor: "#E7F8F7" }}
                >
                  <button
                    className="btn btn-sm btn-link p-1 me-2 "
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={counterDetails.total_submitted_project}
                  >
                    <i className="bi bi-info-circle"></i>
                  </button>
                  <span className="flex-grow-1">
                    Total Submitted: {counter?.total_submitted_project}
                  </span>
                </div>

                {/* Box 4: Total Kickout */}
                <div
                  className="border-1 border border-light-subtle p-3 rounded-3 text-bold d-flex align-items-center"
                  style={{ backgroundColor: "#E7F8F7" }}
                >
                  <button
                    className="btn btn-sm btn-link p-1 me-2 "
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={counterDetails.total_kickout}
                  >
                    <i className="bi bi-info-circle"></i>
                  </button>
                  <span className="flex-grow-1">
                    Total Kickout: {counter?.total_kickout}
                  </span>
                </div>
              </div>

              <div className="row mx-4 graph">
                <div className="col-12 col-md-12 col-lg-12 col-sm-12  my-2 ">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Program Wise Projects</h4>
                      <ProgramWiseProjects
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4 graph">
                {/* <div className="col-12 col-md-12 col-lg-12 col-sm-12 my-4 ">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Projects in Different Stages</h4>
                      <ProjectStageWise
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div> */}

                <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Project Stages</h4>
                      <ProjectStageBar
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4 graph">
                <div className="col-12 col-md-12 col-lg-12 col-sm-12 my-2 ">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>SBU Head WorkLoad</h4>
                      <SBUWorkloadGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Team Leader WorkLoad</h4>
                      <TLWorkloadGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4">
                <div className="col-12 col-md-12 col-lg-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Validator/Verifier Workload</h4>
                      <ValidatorWorkloadGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Trainee Workload</h4>
                      <TraineeWorkloadGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="page-break">
              <div className="row mx-4">
                <div className="col-12 col-md-12 col-lg-12 col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Region Wise Projects</h4>
                      <RegionWiseProjectGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4">
                <div className="col-8 col-md-12 col-lg-8  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Kickout Month Wise</h4>
                      <KickoutMontlyWiseGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-4 col-md-12 col-lg-4  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Project Delayed</h4>
                      <ProjectMovingDateWise
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4">
                <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Contracts Signed vs Delivered</h4>
                      <ContractSignedMonthlyGraph
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4">
                {/* <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Project Stages</h4>
                      <ProjectStageBar />
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="row mx-4">
                <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>RFI Initial Submission</h4>
                      <RFIMonthly
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4">
                <div className="col-12 col-md-12 col-lg-12  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>RFI Resubmission</h4>
                      <KickoutRFI
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-4">
                <div className="col-6 col-md-12 col-lg-6  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Month Wise TR</h4>
                      <KickoutMontlyWiseGraphTR
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-12 col-lg-6  col-sm-12 my-2 graph">
                  <div class="mycard_dash">
                    <div class="mycard-content text-center">
                      <h4>Month Wise CC</h4>
                      <KickoutMontlyWiseGraphCC
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default ProjectDashboard;
